











































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import {
    dateInOriginalOffset,
    formatDate,
    isSameDate,
    monthName,
    zoneNameByOffset
} from "../../common/dateTimeHelper";
import {DateItemInterface} from "./DateItemInterface";
import DatePick from 'vue-date-pick/src/vueDatePick.vue';
import CalendarSvg from '../../assets/svg/calendar.svg';
import {getVueDatePickLocale} from "../../common/vueDatePick";
import {detectMob} from "../../common/mobileHelper";
import SegmentControl from "../common/segment/Segment.vue"
import { SegmentDataItem } from "../common/segment/SegmentData";
import { setPickerSide } from "./helpers";

@Component({
    components: { DatePick, CalendarSvg, SegmentControl }
})
export default class DateSwitcher extends Vue {
    @Prop({default: () => DateTime.local()}) value: DateTime | null;
    @Prop({default: 'day'}) mode: string;
    @Prop({default: 7}) daysInWeek: number;
    @Prop({default: true}) enableDateRestrictions: boolean; // включены ли ограничения на выбор даты в календаре
    @Prop({ default: null }) enabledISODates: string[] | null;

    @Prop({ required: true }) minLimit: DateTime;
    @Prop({ required: true }) maxLimit: DateTime;

    @Prop() customDates: DateItemInterface[] | undefined;
    @Prop({ default: true }) needSetDefaultDate: boolean;

    @Prop({ default: ""}) pickerSide: "left" | "right" | "";
    @Prop({ default: true }) useArrows: boolean;

    @Prop({ default: "left"}) labelSide: "left" | "right" | "";
    @Prop({ default: true }) needLabel: boolean;
    @Prop({ default: true }) needSegment: boolean;

    currentDate: DateTime|null = null;
    vueDatePickLocale: any = {}
    positionFloaterCb = null;

    @Watch('value')
    onValueChange() {
        if(this.value) {
            this.currentDate = dateInOriginalOffset(this.value, this.offset);
        }
        else if(this.value === null) {
            this.currentDate = null;
        }
    }

    mounted() {

        if(!this.isOneDay) {
            this.vueDatePickLocale = getVueDatePickLocale(this.lang);
        }

        if(!this.needSetDefaultDate) {return}

        if(this.isOneDay && this.selectedEvent.beginAt !== this.value) {
            const date = dateInOriginalOffset(this.selectedEvent.beginAt.setLocale(this.lang), this.offset);
            this.$emit('input', date);
            this.currentDate = date
        }
        else {
            this.currentDate = dateInOriginalOffset(this.value ? this.value.setLocale(this.lang) : DateTime.local().setLocale(this.lang), this.offset);
        }
    }

    activated() {
        window.addEventListener('resize', this.setDatePickerSide)
    }

    deactivated() {
        window.removeEventListener('resize', this.setDatePickerSide)
    }

    @Watch('pickerSide')
    watchPickerSide(value: "left" | "right" | "") {

        const picker = (this.$refs["picker"] as { positionClass: string } | any | undefined);

        if(!picker) {
            return
        }

        if(value) {
            this.positionFloaterCb = picker.positionFloater;
            picker.positionFloater = () => {return}
            this.setDatePickerSide(picker)
        }
        else if(this.positionFloaterCb) {
            picker.positionFloater = this.positionFloaterCb
        }
    }

    setDatePickerSide(picker?: any) {

        this.$nextTick(() => {
            if(!picker) {
                picker = (this.$refs["picker"] as { positionClass: string } | any | undefined);
            }

            if(!picker) {
                return
            }

            setPickerSide(picker, this.pickerSide);
        })
    }

    clear() {
        this.currentDate = null;
        this.$emit("input", null)
    }

    openPicker(cb: () => {}) {
        cb();
        if(this.pickerSide) {
            this.setDatePickerSide();
        }
    }

    get segmentData(): SegmentDataItem[] {
        return this.dates.map((item) => {
            return {
                active: this.currentDate && isSameDate(item.date, this.currentDate) || false,
                title: item.formattedDate,
                value: item.date
            }
        });
    }

    get selectedEvent() {
        return this.$store.getters['events/selectedEvent']
    }

    get isCustomDatesEnabled(): boolean {
        return Array.isArray(this.customDates) && this.customDates.length > 0;
    }

    get lang(): string {
        return this.$store.state.session.language || 'en'
    }

    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get days(): number {
        return this.isCustomDatesEnabled
            ? this.customDates?.length || 0
            : Math.round(this.maxLimit.diff(this.minLimit, 'days').days)
    }

    get isSegment() {
        if (!this.enableDateRestrictions) {return false;}
        return (this.days <= 3 && this.mode == 'day');
    }

    get isSegmentShowing(): boolean {
        return detectMob()
            ? this.isSegment
            : this.isSegment || this.isCustomDatesEnabled;
    }

    get isOneDay() {
        if (!this.enableDateRestrictions) {return false;}
        return this.days === 1 && this.mode == 'day';
    }

    get isFirstDay(): boolean {
        if (!this.enableDateRestrictions) {
            return false;
        }
        if (this.currentDate) {
            return isSameDate(this.minLimit, this.currentDate);
        }
        return false;
    }

    get isLastDay(): boolean {
        if (!this.enableDateRestrictions) {
            return false;
        }
        if (this.currentDate) {
            return isSameDate(this.maxLimit, this.currentDate);
        }
        return false;
    }

    get dates(): DateItemInterface[] {
        const result: DateItemInterface[] = [];
        const today = dateInOriginalOffset(DateTime.local(), this.offset);

        if (this.customDates?.length) {
            return this.customDates;
        }

        if (this.isSegment) {
            for (let i = 0; i < this.days; i++) {
                const date = this.minLimit.plus({ days: i });
                result.push({
                    date: date,
                    formattedDate: formatDate(date, this.lang, date.hasSame(today, 'year'))
                })
            }
        }
        return result;
    }

    get formattedDate(): string {
        if (this.currentDate) {
            if (this.mode == 'week') {
                const begin = this.currentDate.startOf('week'),
                      end = this.currentDate.endOf('week');
                // 29.06–05.07
                if (begin.month != end.month) {
                    return `${begin.toFormat('dd.LL')}–${end.toFormat('dd.LL')}`;
                }
                let monthNameStr: string = monthName(begin.month, this.lang);
                if (this.lang == 'ru') {
                    monthNameStr = monthNameStr.toLowerCase();
                }
                return `${begin.day}–${end.day} ${monthNameStr}`;
            }
            return formatDate(this.currentDate, this.lang);
        }
        return '';
    }

    isSameDay = isSameDate;

    changeDate(days: number) {
        let duration = {};
        if (this.mode == 'week') {
            duration = {week: days};
        }
        else {
            if (this.daysInWeek != 7) {
                if (this.currentDate?.weekday == 1 && days < 0) {
                    days = -1 * (7 - this.daysInWeek + 1);
                }
                if (this.currentDate?.weekday == this.daysInWeek && days > 0) {
                    days = (7 - this.daysInWeek + 1);
                }
            }
            duration = {days: days};
        }
        let newDate = (this.currentDate?.plus(duration) as DateTime);

        if(this.enableDateRestrictions && this.minLimit > newDate) {
            newDate = this.minLimit;
        }
        if (this.enableDateRestrictions && this.maxLimit < newDate) {
            newDate = this.maxLimit;
        }
        this.$emit('input', newDate);
    }

    inc() {
        this.changeDate(1);
    }

    dec() {
        this.changeDate(-1);
    }

    setDate(date: DateTime) {
        if (this.currentDate?.toISODate() != date.toISODate()) {
            // this.currentDate = date;
            this.$emit('input', date);
        }
    }

    get currentDateStr(): string {
        return this.currentDate?.toISODate() || '';
    }

    set currentDateStr (value: string) {
        this.$emit('input', DateTime.fromISO(value, {zone: zoneNameByOffset(this.offset)}));
    }

    isDateDisabled(date: Date) {
        if (!this.enableDateRestrictions) {
            return false;
        }
        const newDate: DateTime = DateTime.fromObject({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
            hour: 12,
            minute: 0,
            zone: zoneNameByOffset(this.offset)
        });

        if(this._enabledDates) {
            return !this.dateIsEnabled(newDate, this._enabledDates)
        }

        if (this.isCustomDatesEnabled) {
            const dates = this.$store.getters['events/selectedEventViewParam']('dates', null);

            for (let index in dates) {
                const dateInstance = DateTime.fromFormat(dates[index], "d.MM.yyyy", { zone: zoneNameByOffset(this.offset) });
                if (dateInstance.startOf('day').equals(newDate.startOf('day'))) {
                    return false;
                }
            }

            return true;
        }

        return !(this.minLimit <= newDate && newDate <= this.maxLimit);
    }

    dateIsEnabled(date: DateTime, enabledDates: DateTime[]) {
        return enabledDates.some(enabledDate => enabledDate.startOf('day').equals(date.startOf('day')))
    }

    private get _enabledDates() {
        return this.enabledISODates?.map(date => DateTime.fromISO(date, { zone: zoneNameByOffset(this.offset) })) || null;
    }

    @Watch('lang')
    onLangChanged() {
        this.vueDatePickLocale = getVueDatePickLocale(this.lang);
    }
}
